// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4274225c","703":"ae3fbe39","787":"813be768"}[chunkId] + ".chunk.js";
};